module.exports = __webpack_public_path__ + "img/change.594e93d5.png";